import { HomePage } from "./pages/HomePage";
import type { PluginModule } from "../../plugins/types";

const charlieHomePlugin: PluginModule = {
  routes: [
    {
      path: "home",
      element: <HomePage />,
    },
  ],
  navigation: [
    {
      name: "Home",
      route: "/home",
      icon: "Home",
      order: 0,
    },
  ],
  config: {
    name: "charlieHome",
    version: "1.0.0",
    description: "Charlie home dashboard with quick actions",
  },
};

export default charlieHomePlugin;
